import { useTranslation } from 'react-i18next'

import {
  EMPTY_FUNCTION,
  FLOATING_ELEMENT_PLACEMENT,
} from '../../../../constants/common'
import Button, { BUTTON_HEIGHT_24 } from '../../../Button'
import { GretaAIChatNewProject } from '../../GretaAIChatNewProject'
import { GretaAIChatChatListSectionToggle } from '../GretaAIChatChatListSectionToggle'

import {
  GRETA_AI_CHAT_PROJECTS_ALL_ICON_SIZE,
  QA_NAME_GRETA_AI_CHAT_PROJECTS_ALL,
  QA_NAME_GRETA_AI_CHAT_PROJECTS_TOGGLE,
} from './GretaAIChatChatListProjectsHeader.constants'

import * as styles from './GretaAIChatChatListProjectsHeader.module.css'

import OpenIcon from '../../../../icons/open-in-new-window.svg'
import PlusIcon from '../../../../icons/plus.svg'

function GretaAIChatChatListProjectsHeader({
  isCollapsed = false,
  onOpenProjectsPage = EMPTY_FUNCTION,
  onToggle = EMPTY_FUNCTION,
}) {
  const { t } = useTranslation()

  return (
    <div className={styles.header}>
      <GretaAIChatChatListSectionToggle
        isCollapsed={isCollapsed}
        qaName={QA_NAME_GRETA_AI_CHAT_PROJECTS_TOGGLE}
        title={t('Greta.ProjectsSectionKey')}
        onToggle={onToggle}
      />
      <div className={styles.actions}>
        <Button.Icon
          isGrey
          Icon={OpenIcon}
          beforeIconProps={{ svgSize: GRETA_AI_CHAT_PROJECTS_ALL_ICON_SIZE }}
          className={styles.allProjects}
          height={BUTTON_HEIGHT_24}
          qaName={QA_NAME_GRETA_AI_CHAT_PROJECTS_ALL}
          tooltip={t('Greta.ProjectsAllKey')}
          tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.bottom}
          onClick={onOpenProjectsPage}
        />
        <GretaAIChatNewProject
          triggerProps={{
            Icon: PlusIcon,
            className: styles.actionButton,
            height: BUTTON_HEIGHT_24,
            isGrey: true,
            tooltip: t('Greta.NewProjectKey'),
            tooltipPlacement: FLOATING_ELEMENT_PLACEMENT.bottom,
          }}
        />
      </div>
    </div>
  )
}

export default GretaAIChatChatListProjectsHeader
